
const EventEmitter2 = require('eventemitter2');
const eventBus = new EventEmitter2({
	wildcard: true,
	ignoreErrors: false
})
export default eventBus
